'use client'
import React from 'react'

import CancelEditSaleOrderModal from '../components/CancelEditSaleOrderModal'
import SubmitEditSaleOrderModal from '../components/SubmitEditSaleOrderModal'
import { useEditSaleOrderModal } from '../hooks/useEditSaleOrderModal'

import { EditSaleOrderModalsContext } from './EditSaleOrderModalsContext'

export const EditSaleOrderModalsProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const modal = useEditSaleOrderModal()

  return (
    <EditSaleOrderModalsContext.Provider value={modal}>
      {children}
      <CancelEditSaleOrderModal
        open={modal.cancelEditOpen}
        onClose={modal.handleCloseCancelEditModal}
      />
      <SubmitEditSaleOrderModal
        onClose={modal.handleCloseSubmitEditModal}
        open={modal.submitEditOpen}
      />
    </EditSaleOrderModalsContext.Provider>
  )
}
